<template>
  <div v-if="testdrive.loading">
    <loading-component class="hidden-xs"></loading-component>
  </div>
  <div
    v-else
    class="modal-content"
    style="width: inherit; height: inherit; margin: 0 auto"
  >
    <div class="modal-header">
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 id="modal_title" class="modal-title">Upgrade Test Drive</h4>
    </div>
    <div class="modal-body">
      <get-product-select
        @product-selected="productSelected"
      ></get-product-select>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" @click="upgradeTestDrive">
        Upgrade
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import store from "../../store/stores";
import GetProductSelect from "./GetProductSelect.vue";

export default {
  name: "UpgradeTestDriveForm",
  components: { GetProductSelect },
  store,
  data() {
    return {
      selectedItemId: "",
    };
  },
  computed: {
    ...mapState(["testdrive"]),
  },
  methods: {
    productSelected(itemId) {
      this.selectedItemId = itemId;
    },
    upgradeTestDrive(event, itemId = this.selectedItemId) {
      this.$store.dispatch("testdrive/upgradeTestDrive", itemId);
    },
  },
};
</script>

<style scoped></style>
